import { Input } from 'antd';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import styles from './OTPInput.module.scss';
import cn from 'classnames';

export const OTPInput = forwardRef(
  (
    { length = 6, value: externalValue, onChange, setIsComplete, disabled },
    ref
  ) => {
    const inputRef = useRef([]);
    const [value, setValue] = useState(new Array(length).fill(''));
    const [otpError] = useState('');

    const onChangeHandler = ({ target: { value: inputValue } }, index) => {
      if (isNaN(inputValue) || disabled) return;

      const numericValue = inputValue.replace(/\D/g, '').trim();

      const newValue = [...value];
      newValue[index] = numericValue.slice(-1);
      setValue(newValue);

      if (inputValue && index < length - 1) {
        inputRef.current[index + 1].focus();
      }

      const finalValue = newValue.join('');
      onChange(finalValue);
      if (finalValue.length === length) {
        setIsComplete(true);
      } else {
        setIsComplete(false);
      }
    };

    const onClickHandler = (index) => {
      if (inputRef.current[index]) {
        inputRef.current[index].focus();
      }
    };

    const onKeyDownHandler = (e, index) => {
      if (e.key === 'Backspace' && index > 0 && !value[index]) {
        inputRef.current[index - 1].focus();
      }
    };

    useEffect(() => {
      inputRef.current[0].focus();
    }, []);

    useEffect(() => {
      if (!externalValue) {
        setValue(new Array(length).fill(''));
        setIsComplete(false);
        return;
      }
      const cells = new Array(length).fill('');
      for (let i = 0; i < Math.min(externalValue.length, length); i++) {
        cells[i] = externalValue[i];
      }
      setValue(cells);
      setIsComplete(externalValue.length === length);
    }, [externalValue, length, setIsComplete]);

    return (
      <div
        className={styles.root}
        ref={ref}
      >
        <div>
          {value.map((item, index) => (
            <Input
              key={index}
              ref={(input) => (inputRef.current[index] = input)}
              value={item}
              className={cn(styles.otpInput, {
                [styles.otpInputError]: otpError,
              })}
              maxLength={1}
              placeholder="_"
              disabled={disabled}
              onChange={(e) => onChangeHandler(e, index)}
              onClick={() => onClickHandler(index)}
              onKeyDown={(e) => onKeyDownHandler(e, index)}
            />
          ))}
        </div>
        <span className={styles.otpError}>{otpError}</span>
      </div>
    );
  }
);
